export const SEARCH_RESULTS_TARGET = 'searchResults';

export const CATEGORIES_TARGET = 'categories';

export const ARTICLES_TARGET = 'articles';

export const SELECTED_QUESTION_TARGET = 'selectedQuestion';

export const SECTIONS_TARGET = 'sections';
